import React, { useEffect, useState } from 'react';
import { Block, BlockBetween, BlockHead, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, Row } from '../../../../../../components/Component';
import { Alert, Spinner } from 'reactstrap';
import { useDispatch } from 'react-redux';
import * as app_consts from "../../../../../../constants/react_app_consts";
import { ADD_PRODUCTS_TO_WAREHOUSE_DELIVERY_DN_API, RETRIEVE_ADD_DELIVERY_NOTE_PRODUCTS_API } from '../../../../../../api/api_data';
import { CREATE_DIRECT_DELIVERY_NOTE_PRODUCTS_ACCESS_DENIED_MSG, CREATE_DIRECT_DELIVERY_NOTE_PRODUCTS_ERR_MSG, CREATE_DIRECT_DELIVERY_NOTE_PRODUCTS_SUCCESS_MSG, RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG, RETRIEVE_PRODUCTS_LIST_ERR_MSG, RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { fail_product_list, loading_product_list, reset_product_list, success_product_list } from '../../../../../../reducers/dashboard_reducers/products/product_list_Slice';
import { messageToast } from '../../../../../../utils/Utils';
import { useSelector } from 'react-redux';
import { BiErrorCircle } from 'react-icons/bi';
import TextInput from '../../../../../components/inputs/TextInput';
import ModalConfirmCancel from '../../modal_confirm_cancel/ModalConfirmCancel';
import { fail_create_delivery_note_product, loading_create_delivery_note_product, reset_create_delivery_note_product, success_create_delivery_note_product } from '../../../../../../reducers/dashboard_reducers/delivery_notes/create_delivery_note_product_Slice';
import { reset_add_product_to_loading_order } from '../../../../../../reducers/dashboard_reducers/loading_orders/add_product_to_loading_order_Slice';

const initialState = {};
const UNKNOWN_PACKET_SIZE = "Unknown";

const isUnknownPacketSize = (packetSize) => String(packetSize || "").toLowerCase() === UNKNOWN_PACKET_SIZE.toLowerCase();

const isGrainProduct = (productType = "", product = "") =>
  [productType, product].some((value) => String(value || "").toLowerCase().includes("grain"));

const isUnknownGrainPacket = (item = {}) => isUnknownPacketSize(item?.packet_size) && isGrainProduct(item?.product_type, item?.product_name);

const AddProductsToWarehouseDeliveryNoteModal = ({ page_data, openModal, successFunction }) => {

  const dispatch = useDispatch();
  const [productListLoading, setProductListLoading] = useState(true);
  const [productListError, setProductListError] = useState(true);
  const [product_data, setProductData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent_data, setSentData] = useState(page_data);
  const [goodsReceivedProductItems, setGoodsReceivedProductItems] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [formData, setFormData] = useState(initialState);
  const [productsList, setProductsList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [packet_sizes, setPacketSizes] = useState([]);
  const [openConfirmCancelModal, setOpenConfirmCancelModal] = useState(false);
  const [error_confirm, setErrorConfirm] = useState(false);
  const [added_products, setAddedProducts] = useState([]);

  useEffect(() => {
    if (openModal && page_data)
    {
      setProductListError("");
      // Retrieve Product List
      dispatch(
        employee_dashboard_actions_helper(
          loading_product_list,
          success_product_list,
          fail_product_list,
          RETRIEVE_PRODUCTS_LIST_ERR_MSG,
          RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
          app_consts.GET,
          `${RETRIEVE_ADD_DELIVERY_NOTE_PRODUCTS_API}/${page_data?.delivery_note?.delivery_note_ref_number}`,
          null,
          RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG
        )
      );
    }
    setSentData(page_data);
    setGoodsReceivedProductItems([]);
  }, [openModal, page_data]);

  //Listen to State of Product List
  const product_list = useSelector((state) => state.product_list.product_list);

  useEffect(() => {
    if (product_list.status !== app_consts.IDLE)
    {
      if (product_list.status === app_consts.LOADING)
      {
        setProductListLoading(true);
      } else
      {
        setProductListLoading(false);
        if (product_list.status === app_consts.FAIL)
        {
          setProductListError(product_list.message);
          messageToast(product_list.message, app_consts.FAIL);
        } else if (product_list.status === app_consts.SUCCESS)
        {
          setGoodsReceivedProductItems(product_list.data);
        }
        dispatch(reset_product_list());
      }
    }
  }, [product_list]);

  const handleCheckboxChange = (item) => {
    setAddedProducts(prev => {
      const exists = prev.some(prod =>
        prod.packet_size === item.packet_size &&
        prod.product_id === item.product_id &&
        prod.branch_location_id === item.branch_location_id &&
        prod.warehouse_storage_id === item.warehouse_storage_id
      );

      if (exists)
      {
        return prev.filter(prod =>
          !(
            prod.packet_size === item.packet_size &&
            prod.product_id === item.product_id &&
            prod.branch_location_id === item.branch_location_id &&
            prod.warehouse_storage_id === item.warehouse_storage_id
          )
        );
      }

      // Add it with initial values if it doesn't exist
      return [...prev, {
        ...item,
        packaging_number: item.packaging_number || 0,
        quantity_in_mt: item.quantity_in_mt || 0
      }];
    });
  };



  // Function to update added product values
  const updateAddedProduct = (itemToUpdate, field, value) => {
    setAddedProducts(prev =>
      prev.map(item =>
        isSameProduct(item, itemToUpdate)
          ? { ...item, [field]: value }
          : item
      )
    );
  };

  const isSameProduct = (a, b) => {
    return (
      a.packet_size === b.packet_size &&
      a.product_id === b.product_id &&
      a.branch_location_id === b.branch_location_id &&
      a.warehouse_storage_id === b.warehouse_storage_id
    );
  };

  const handleSubmit = () => {
    setErrorConfirm(false);
    const sent_data = { products: added_products, delivery_note_ref_number: page_data?.delivery_note?.delivery_note_ref_number };
    dispatch(
      employee_dashboard_actions_helper(
        loading_create_delivery_note_product,
        success_create_delivery_note_product,
        fail_create_delivery_note_product,
        CREATE_DIRECT_DELIVERY_NOTE_PRODUCTS_ERR_MSG,
        CREATE_DIRECT_DELIVERY_NOTE_PRODUCTS_SUCCESS_MSG,
        app_consts.POST,
        ADD_PRODUCTS_TO_WAREHOUSE_DELIVERY_DN_API,
        sent_data,
        CREATE_DIRECT_DELIVERY_NOTE_PRODUCTS_ACCESS_DENIED_MSG
      )
    );
  };

  //Listen to State of Product List
  const create_delivery_note_product = useSelector((state) => state.create_delivery_note_product.create_delivery_note_product);

  useEffect(() => {
    if (create_delivery_note_product.status !== app_consts.IDLE)
    {
      if (create_delivery_note_product.status === app_consts.LOADING)
      {
        setErrorConfirm("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (create_delivery_note_product.status === app_consts.FAIL)
        {
          messageToast(create_delivery_note_product.message, app_consts.FAIL);
          setErrorConfirm(create_delivery_note_product.message);
        } else if (create_delivery_note_product.status === app_consts.SUCCESS)
        {
          messageToast(CREATE_DIRECT_DELIVERY_NOTE_PRODUCTS_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
        }
        dispatch(reset_create_delivery_note_product());
      }
    }
  }, [create_delivery_note_product]);

  return (
    <>
      <div className="card-inner bg-white">
        {
          productListLoading ?
            <>
              <div className='p-5 d-flex align-center justify-center'>
                <Spinner />
              </div>
            </>
            :
            <>
              {
                productListError && productListError.length > 0 ?
                  <>
                    <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                      <BiErrorCircle className="text-danger fs-3" />
                      <p>{productListError}</p>
                    </div>
                  </>
                  :
                  <>
                    <Block>
                      <BlockHead>
                        <BlockTitle tag="h5">Products</BlockTitle>
                      </BlockHead>
                      {error && (
                        <div className="mb-3 w-100">
                          <Alert color="danger" className="alert-icon">
                            <Icon name="alert-circle" /> {error}{" "}
                          </Alert>
                        </div>
                      )}
                      <div className="nk-tb-list is-separate is-medium mb-3">
                        <DataTableHead className="nk-tb-item">
                          <DataTableRow size="lg"><span className="sub-text">Branch Location</span></DataTableRow>
                          <DataTableRow size="lg"><span className="sub-text">Product</span></DataTableRow>
                          <DataTableRow size="lg"><span className="sub-text">Delivery</span></DataTableRow>
                          <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
                          <DataTableRow size="lg"><span className="sub-text">Total Quantity (MT)</span></DataTableRow>
                          <DataTableRow size="lg"><span className="sub-text">Quantity Loaded</span></DataTableRow>
                          <DataTableRow size="lg"><span className="sub-text">Packaging Number</span></DataTableRow>
                          <DataTableRow size="lg"><span className="sub-text">Quantity (MT)</span></DataTableRow>
                          <DataTableRow size="lg"><span className="sub-text"></span></DataTableRow>
                        </DataTableHead>
                        {goodsReceivedProductItems.length > 0 &&
                          goodsReceivedProductItems.map((item, index) => {


                            const isAdded = added_products.some(prod =>
                              prod.packet_size === item.packet_size &&
                              prod.product_id === item.product_id &&
                              item.branch_location_id === prod.branch_location_id &&
                              item.warehouse_storage_id === prod.warehouse_storage_id
                            );
                            const unknownPacketSelected = isUnknownGrainPacket(item);

                            return (
                              <DataTableItem key={index}>
                                <DataTableRow>
                                  <span className="tb-sub">{
                                    item?.branch_name || "---"
                                  }</span>
                                  <div>
                                    <span className="fw-medium">Storage Type: </span>
                                    <span className="tb-sub">{item?.warehouse_storage || "--"}</span>
                                  </div>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="tb-sub">{
                                    item?.product_name?.toUpperCase() || "---"
                                  }</span>
                                  <div>
                                    <span className="fw-medium">Product Type: </span>
                                    <span className="tb-sub">{item?.product_type?.toUpperCase() || "--"}</span>
                                  </div>
                                </DataTableRow>
                                <DataTableRow ><span className="tb-sub">{item?.delivery_location || "--"}</span></DataTableRow>
                                <DataTableRow>
                                  <span className="tb-sub">{
                                    item?.packet_size?.toUpperCase() || "---"
                                  }</span>
                                  <div>
                                    <span className="fw-medium">Product Type(KGs): </span>
                                    <span className="tb-sub">{item?.product_type?.toUpperCase() || "--"}</span>
                                  </div>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="tb-sub">{
                                    item?.total_capacity_in_mt ? parseFloat(item?.total_capacity_in_mt)?.toFixed(2) : "---"
                                  }</span>
                                  <div>
                                    <span className="fw-medium">Unit Weight(KGs): </span>
                                    <span className="tb-sub">{
                                      unknownPacketSelected ? "---" : item?.measurement_in_kilos ? parseFloat(item?.measurement_in_kilos)?.toFixed(2) : "---"
                                    }</span>
                                  </div>
                                </DataTableRow>
                                <DataTableRow><span className="tb-sub">{item?.tonnage_loaded || "0.00"}</span></DataTableRow>
                                <DataTableRow>
                                  <Row className="g-4">
                                    <TextInput
                                      required
                                      type="number"
                                      value={isAdded
                                        ? added_products.find(prod => isSameProduct(prod, item))?.packaging_number_loaded
                                        : item?.packaging_number_loaded
                                      }
                                      colSize="10"
                                      disabled={!isAdded}
                                      handleChange={(e) => {
                                        const selected = parseFloat(e.target.value) || 0;

                                        if (unknownPacketSelected)
                                        {
                                          updateAddedProduct(item, 'packaging_number_loaded', selected);
                                          return;
                                        }

                                        const density = parseFloat(item.measurement_in_kilos) || 0;
                                        const totalMT = density ? (selected * density) / 1000 : 0;

                                        updateAddedProduct(item, 'packaging_number_loaded', selected);
                                        updateAddedProduct(item, 'quantity_in_mt_loaded', totalMT);
                                      }}
                                    />
                                  </Row>
                                </DataTableRow>

                                <DataTableRow>
                                  <Row className="g-4">
                                    <TextInput
                                      required
                                      type="number"
                                      value={isAdded
                                        ? added_products.find(prod => isSameProduct(prod, item))?.quantity_in_mt_loaded
                                        : item?.quantity_in_mt_loaded
                                      }
                                      colSize="10"
                                      disabled={!isAdded || !item?.packet_size}
                                      handleChange={(e) => {
                                        const totalMT = parseFloat(e.target.value) || 0;

                                        if (unknownPacketSelected)
                                        {
                                          updateAddedProduct(item, 'quantity_in_mt_loaded', totalMT);
                                          return;
                                        }

                                        const density = parseFloat(item.measurement_in_kilos) || 0;
                                        const selectedMeasurement = density ? (totalMT * 1000) / density : 0;

                                        updateAddedProduct(item, 'packaging_number_loaded', selectedMeasurement);
                                        updateAddedProduct(item, 'quantity_in_mt_loaded', totalMT);
                                      }}
                                    />
                                  </Row>
                                </DataTableRow>
                                <DataTableRow>
                                  <input
                                    type="checkbox"
                                    checked={isAdded}
                                    onChange={() => handleCheckboxChange(item)}
                                  />
                                </DataTableRow>
                              </DataTableItem>
                            );
                          }
                          )}
                      </div>
                      <BlockBetween>
                        <div></div>
                        {
                          sent_data?.weigh_bridge_ticket_status?.weigh_bridge_ticket_status?.toLowerCase() === app_consts.PROCESSING_OUTBOUND && added_products?.length > 0 && (
                            <>
                              <Button className="my-4" color="primary"
                                size="md" onClick={() => setOpenConfirmCancelModal(!openConfirmCancelModal)}>Add Products</Button>
                            </>
                          )
                        }
                      </BlockBetween>
                    </Block>
                  </>
              }

              {/* Yes or No Modal */}
              <ModalConfirmCancel
                openModal={openConfirmCancelModal}
                setOpenModal={setOpenConfirmCancelModal}
                modalTitle={`Add Products to Delivery Note ${sent_data?.delivery_note?.delivery_note_ref_number}`}
                modalDescription={`Are you sure that you want to Add Products to ${sent_data?.delivery_note?.delivery_note_ref_number}?`}
                buttonConfirm="Confirm"
                buttonCancel="Cancel"
                succFunc={handleSubmit}
                errAmend={error_confirm}
                setErrAmend={setErrorConfirm}
              />
            </>
        }
      </div>

    </>
  );
};

export default AddProductsToWarehouseDeliveryNoteModal;
